import axios from "axios"
import { sha512 } from "crypto-hash"
import { useEffect, useState } from "react"
import { Link, useNavigate, useSearchParams } from "react-router-dom"
import { toast } from "react-toastify"
import { isLoggedIn } from "../user/User"
import FormButton from "../components/FormButton"

const ResetPassword = () => {
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()
    let token = searchParams.get("token")
    let email = searchParams.get("email")
    const [password, setPassword] = useState("")
    const [isLoading, setIsLoading] = useState(false)
    useEffect(() => {
        if (isLoggedIn()) {
            navigate("/")
        }
    })

    async function resetPassword(navigate) {
        setIsLoading(true)
        var passwordHash = await sha512(password)
        axios.post(process.env.REACT_APP_API_URL + "/reset/" + token, JSON.stringify({
            "email": email,
            "password": passwordHash
        })).then(_ => {
            toast.success("Dein Passwort wurde geändert.")
            navigate("/login")
        }).catch(error => {
            console.error(error)
            if (error.response) {
                setIsLoading(false)
                var statusCode = error.response.status
                if(statusCode === 400) {
                    toast.error("Ungültige Anfrage.")
                    return
                } else if(statusCode === 404) {
                    toast.error("Es existiert kein Benutzer mit dieser E-Mail-Adresse oder es wurde keine Passwortänderung angefragt.")
                    return
                }
            }
            toast.error("Serverfehler")
        })
    }

    const handleSubmit = async e => {
        e.preventDefault()
        resetPassword(navigate)
    }

    return (
        <div className="login-page">
            <div className="login-box">
                <div className="card card-outline card-primary">
                    <div className="card-header text-center">
                        <h1>{process.env.REACT_APP_APP_NAME}</h1>
                    </div>
                    <div className="card-body">
                        <p className="login-box-msg">Gebe dein neues Passwort ein</p>
                        <form onSubmit={handleSubmit}>
                            <FormButton placeholder="Passwort" id="password" required="required" value={password} setValue={setPassword} icon="fas fa-lock" type="password" minLength={8} size="mb-3" />
                            <div className="form-group row">
                                {
                                    isLoading ? 
                                    <button type="submit" className="btn btn-primary btn-block" disabled>Passwort wird zurückgesetzt...</button>
                                    :
                                    <button type="submit" className="btn btn-primary btn-block">Passwort zurücksetzen</button>
                                }
                            </div>
                        </form>

                        <p className="mt-3 mb-1">
                            <Link to="/login">Anmelden</Link>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}
 
export default ResetPassword